import Title from "./Title";
import Content from "./Content";
import { PageContentWrapper } from "../../shared/styled/PageContentStyle";
import { useState } from "react";
import { ColumnMapping, downloadExcel } from "../../utils/exportUtils";
import { AlertModal } from "./AlertModal";
import { buildDeliveryTripReportRows } from "./reportRows";

const DeliveryTrips = () => {
    const [isOpenAlertModal, setIsOpenAlertModal] = useState(false);
    const [alertTextReport, setAlertTextReport] = useState('');
    const [activeTab, setActiveTab] = useState("list");
    const [planActionsContainer, setPlanActionsContainer] = useState<HTMLDivElement | null>(null);
    const [selectedItems, setSelectedItems] = useState<any[]>([]);

    const handleSelectionChange = (selectedItems: any[]) => {
        setSelectedItems(selectedItems);
    };

    const handleExport = async () => {
        if (selectedItems.length === 0) {
            setAlertTextReport('Vui lòng chọn ít nhất một chuyến vận chuyển để xuất báo cáo.');
            setIsOpenAlertModal(true);
            return;
        }

        const processedItems: any[] = [];

        await Promise.all(selectedItems.map(async (item, index_count) => {
            const { product_orders, car_plate } = item;

            await Promise.all(product_orders.map(async (order: any) => {
                if (order.delivery_trips && order.delivery_trips.length > 0) {
                    order.delivery_trips.forEach((trip: any) => {
                        if (trip.delivery_products && trip.delivery_products.length > 0) {
                            trip.delivery_products.forEach((deliveryProduct: any, productIndex: number) => {
                                const itemName = deliveryProduct.product?.name || deliveryProduct.material?.name || "N/A";
                                console.log(order.customer?.contact_list[0]?.name, "order.customer?.contact_list[0]?.name");
                                console.log(order.customer?.contact_list[0]?.email, "order.customer?.contact_list[0]?.email");


                                const processedItem = {
                                    idx: index_count + 1,
                                    name: order.name || "N/A",
                                    date: item.date,
                                    car_plate,
                                    customerName: order.customer?.name || "N/A",
                                    customerAddress: order.customer?.address || "N/A",
                                    buyerName: order.customer?.contact_list[0]?.contact.name || "N/A",
                                    buyerEmail: order.customer?.contact_list[0]?.contact.email || "N/A",
                                    tax_id: order.customer?.tax_id || "N/A",
                                    paymentMethod: "",
                                    gtgt_percentage: "",
                                    gtgt_amount: "",
                                    unit: "",
                                    productName: itemName,
                                    quantity: deliveryProduct.quantity || 0,
                                    singlePrice: 0,
                                    totalPrice: 0,
                                };
                                processedItems.push(processedItem);
                            });
                        }
                    });
                }
            }));
        }));

        if (processedItems.length === 0) {
            setAlertTextReport('Không có dữ liệu để xuất hóa đơn. Vui lòng kiểm tra lại các chuyến vận chuyển đã chọn.');
            setIsOpenAlertModal(true);
            return;
        }

        const columnMapping: ColumnMapping = {
            idx: "STT",
            car_plate: "Biển số xe",
            date: "Ngày hóa đơn",
            customerName: "Tên khách hàng",
            customerAddress: "Địa chỉ",
            buyerName: "Tên người mua",
            tax_id: "Mã số thuế",
            buyerEmail: "Email",
            paymentMethod: "Phương thức thanh toán",
            gtgt_percentage: "Thuế suất GTGT (%)",
            gtgt_amount: "Tiền thuế GTGT",
            productName: "Tên hàng hoá/dịch vụ (*)",
            unit: "DVT",
            quantity: "Số lượng",
            singlePrice: "Đơn giá",
            totalPrice: "Thành tiền",
        };

        downloadExcel(
            processedItems.sort((a, b) => a.idx - b.idx),
            columnMapping,
            "Hoá đơn vận chuyển",
            "hoa_don_van_chuyen",
            false,
        );
    };

    const handleReport = async () => {
        if (selectedItems.length === 0) {
            setAlertTextReport('Vui lòng chọn ít nhất một chuyến vận chuyển để xuất báo cáo.');
            setIsOpenAlertModal(true);
            return;
        }

        const processedItems = buildDeliveryTripReportRows(selectedItems);

        if (processedItems.length === 0) {
            setAlertTextReport('Không có dữ liệu để xuất hóa đơn. Vui lòng kiểm tra lại các chuyến vận chuyển đã chọn.');
            setIsOpenAlertModal(true);
            return;
        }

        const columnMapping: ColumnMapping = {
            idx: "STT",
            vehicle_plate: "Biển số xe",
            scheduled_at: "Ngày giờ giao hàng",
            delivery_address: "Địa chỉ giao hàng",
            productOrderName: "Mã đơn hàng",
            productCode: "Mã sản phẩm",
            productName: "Tên sản phẩm",
            quantity: "Số lượng",
        };

        downloadExcel(
            processedItems.sort((a, b) => a.idx - b.idx),
            columnMapping,
            "Báo cáo chuyến vận chuyển",
            "bao_cao_chuyen_van_chuyen",
            false,
        );
    }

    return (
        <PageContentWrapper>
            {isOpenAlertModal && (
                <AlertModal
                    text={alertTextReport}
                    open={isOpenAlertModal}
                    handleClose={() => setIsOpenAlertModal(false)}
                />
            )}
            <Title handleExport={handleExport} handleReport={handleReport} activeTab={activeTab} actionsRef={setPlanActionsContainer} />
            <Content handleSelectionChange={handleSelectionChange} activeTab={activeTab} onTabChange={setActiveTab} planActionsContainer={planActionsContainer} />
        </PageContentWrapper>
    );
};

export default DeliveryTrips;
